import { format } from 'date-fns';

function exactDate(date, formatter = 'DD-MM-YYYY', splitBy = 'T') {
	if (date) {
		const dateSplit = date.split(splitBy);
		const dateComplete = dateSplit[0].split('-');
		const year = dateComplete[0];
		const month = dateComplete[1] - 1;
		const day = dateComplete[2];
		const newDate = format(new Date(year, month, day), formatter);
		return newDate;
	}
	return null;
}

function formatDate(date, formatter = 'DD-MM-YYYY') {
	const newDate = format(new Date(date), formatter);
	return newDate;
}

function generateBlob(data, contentType = 'application/pdf') {
	return new Blob([data], { type: contentType });
}

function getLocalData(key) {
	return JSON.parse(localStorage.getItem(`${process.env.STORAGE_USER_KEY}::${key}`));
}

function getLocalStorage() {
	return JSON.parse(localStorage.getItem(`${process.env.STORAGE_USER_KEY}`));
}

function getLocalToken() {
	return localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
}

function removeLocalData(key) {
	return localStorage.removeItem(`${process.env.STORAGE_USER_KEY}::${key}`);
}

function setLocalData(key, data) {
	return localStorage.setItem(`${process.env.STORAGE_USER_KEY}::${key}`, JSON.stringify(data));
}

function showDownloadDialog(blob, name, extension) {
	const currentDate = format(new Date(), 'YYYY-MM-DD');
	const link = document.createElement('a');
	link.download = `${name}_${currentDate}.${extension}`;
	link.href = window.URL.createObjectURL(blob);
	link.click();
}

/* eslint-disable */
function debounce(func, wait = 800, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function roundTo(number, decimalNumber) {
	const factor = Math.pow(10, decimalNumber);
	return Math.round(number * factor) / factor;
};

function calculateExperience(valueTable, code, valueInput) {
	const totalMounthTable = 60;
	let percentage = [];
	percentage.push(valueTable);
	let cont = 0;
	while (cont < totalMounthTable) {
		if (cont !== 0) {
			percentage[cont] = percentage[cont - 1] + valueTable;
		}
		cont += 1;
	}
	const exponencial = percentage.map(num => Math.exp(roundTo(num / 100, 4)));
	if (code === 'EXA') {
		percentage = percentage.map(num => roundTo(num, 2));
		return percentage[valueInput - 1];
	} else if (code === 'EXB') {
		const typeB = exponencial.map(exp => roundTo((exp - 1) * 50, 2));
		return typeB[valueInput - 1];
	} else if (code === 'EXC') {
		const typeC = exponencial.map(exp => roundTo(((exp - 1) * (1 / 3)) * 100, 2));
		return typeC[valueInput - 1];
	}
};

function calculateTraining(valueTableTrainig, code, valueInput) {
	const totalHoursTable = 200;
	let percentage = [];
	percentage.push(valueTableTrainig);
	let cont = 0;
	while (cont < totalHoursTable) {
		if (cont !== 0) {
			percentage[cont] = percentage[cont - 1] + valueTableTrainig;
		}
		cont += 1;
	}
	const exponencial = percentage.map(num => Math.exp(roundTo(num / 100, 4)));
	if (code === 'CA') {
		percentage = percentage.map(num => roundTo(num, 2));
		return percentage[valueInput - 1];
	} else if (code === 'CB') {
		const typeB = exponencial.map(exp => roundTo((exp - 1) * 50, 2));
		return typeB[valueInput - 1];
	} else if (code === 'CC') {
		const typeC = exponencial.map(exp => roundTo(((exp - 1) * (1 / 3)) * 100, 2));
		return typeC[valueInput - 1];
	}
};

function calculateYears(date, isInt = false) {
	const entry = new Date(date);
	const now = new Date();
	const diffInMilliseconds = now - entry;
	const diffInYears = diffInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
	if (!isInt) {
		return parseFloat(diffInYears.toFixed(2));
	}
	return parseInt(diffInYears, 10);
}

const methods = {
	debounce,
	roundTo,
	calculateExperience,
	calculateTraining,
	exactDate,
	formatDate,
	generateBlob,
	getLocalData,
	getLocalStorage,
	getLocalToken,
	removeLocalData,
	setLocalData,
	showDownloadDialog,
	calculateYears,
};

export default methods;



// WEBPACK FOOTER //
// ./src/shared/helper.js